import { render, staticRenderFns } from "./LocationsAndWebsiteCard.vue?vue&type=template&id=22f50602&scoped=true&"
import script from "./LocationsAndWebsiteCard.vue?vue&type=script&lang=ts&"
export * from "./LocationsAndWebsiteCard.vue?vue&type=script&lang=ts&"
import style0 from "./LocationsAndWebsiteCard.vue?vue&type=style&index=0&id=22f50602&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f50602",
  null
  
)

export default component.exports